export default __webpack_public_path__ + "static/media/pancakeswapicon.c80710ee.svg";